import { Box, Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import heroAtto1 from '../images/atto-1-perubahan/WhatsApp Image 2026-05-15 at 9.13.17 AM.jpeg';
import shiftByWireClose from '../images/atto-1-perubahan/WhatsApp Image 2026-05-15 at 9.13.15 PM.jpeg';
import shiftByWireCabin from '../images/atto-1-perubahan/WhatsApp Image 2026-05-15 at 9.13.16 PM.jpeg';
import fixedPad from '../images/atto-1-perubahan/WhatsApp Image 2026-05-15 at 9.13.17 AM.jpeg';
import stalkControl from '../images/atto-1-perubahan/WhatsApp Image 2026-05-15 at 9.13.17 PM.jpeg';
import retractMirror from '../images/atto-1-perubahan/WhatsApp Image 2026-05-15 at asd.jpeg';
import PageSeo, {
  articleJsonLd,
  breadcrumbJsonLd,
  keywordSets,
  localBusinessJsonLd,
  productJsonLd,
} from '../PageSeo';

const waLink =
  'https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20ingin%20info%20perubahan%20fitur%20BYD%20Atto%201%20NIK%202026%20dan%20harga%20terbaru%20di%20BYD%20BSD%20Serpong';

const variantUpdates = [
  {
    variant: 'Atto 1 Dynamic NIK 2026',
    price: 'Rp210 juta*',
    points: [
      'Retract mirror ditambahkan.',
      'Kursi pengemudi upgrade ke electric seat 6-way.',
      'Shift by wire untuk ruang konsol tengah yang lebih lega.',
      'Spion eksterior berubah menjadi warna hitam.',
      'Headliner berubah dari knitted fabric ke non-woven fabric.',
      'Defogger spion dan defogger kaca belakang tidak tersedia.',
      'Layar PAD fixed dan tidak lagi mendukung rotasi.',
    ],
  },
  {
    variant: 'Atto 1 Premium NIK 2026',
    price: 'Rp245 juta*',
    points: [
      'Retract mirror ditambahkan.',
      'Kursi pengemudi upgrade ke electric seat 6-way.',
      'Kamera upgrade menjadi 360 panoramic camera.',
      'Shift by wire untuk ruang konsol tengah yang lebih lega.',
      'Headliner berubah dari knitted fabric ke non-woven fabric.',
      'Defogger spion dan defogger kaca belakang tidak tersedia.',
      'Layar PAD fixed dan tidak lagi mendukung rotasi.',
    ],
  },
];

const visualCards = [
  {
    image: shiftByWireClose,
    title: 'Shift by wire',
    text: 'Tuas transmisi berpindah ke area steering column, membuat konsol tengah terlihat lebih bersih.',
  },
  {
    image: fixedPad,
    title: 'Layar PAD fixed',
    text: 'Layar tetap menjadi pusat kontrol, tetapi pada update NIK 2026 tidak lagi mendukung rotasi.',
  },
  {
    image: retractMirror,
    title: 'Retract mirror',
    text: 'Tombol pengaturan spion sudah mendukung pelipatan elektrik pada update Atto 1 baru.',
  },
  {
    image: shiftByWireCabin,
    title: 'Layout dashboard',
    text: 'Perubahan posisi gear selector membuat area dashboard dan konsol terasa lebih praktis.',
  },
  {
    image: stalkControl,
    title: 'Kontrol stalk',
    text: 'Kontrol lampu, sein, dan wiper tetap mudah dijangkau untuk penggunaan harian.',
  },
];

const faqItems = [
  {
    question: 'Apa perubahan utama BYD Atto 1 NIK 2026?',
    answer:
      'Perubahan utama meliputi retract mirror, electric seat 6-way di Dynamic dan Premium, shift by wire, 360 camera untuk Premium, layar PAD fixed, headliner non-woven fabric, serta penyesuaian fitur di varian Dynamic dan Premium.',
  },
  {
    question: 'Apa update fitur BYD Atto 1 Dynamic 2026?',
    answer:
      'Dynamic mendapat retract mirror, electric seat 6-way, shift by wire, spion hitam, headliner non-woven fabric, defogger spion dan kaca belakang tidak tersedia, serta layar PAD fixed.',
  },
  {
    question: 'Apa update fitur BYD Atto 1 Premium 2026?',
    answer:
      'Premium mendapat retract mirror, electric seat 6-way, 360 camera, shift by wire, headliner non-woven fabric, defogger tidak tersedia, dan layar PAD fixed.',
  },
  {
    question: 'Berapa harga BYD Atto 1 NIK 2026?',
    answer:
      'Harga indikatif yang digunakan di halaman ini adalah Dynamic Rp210 juta dan Premium Rp245 juta. Harga dapat berubah mengikuti OTR, promo, dan ketersediaan unit.',
  },
];

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

function PerubahanAtto1Detail() {
  return (
    <>
      <PageSeo
        title='Perubahan Fitur BYD Atto 1 NIK 2026 | Dynamic & Premium'
        description='Ringkasan perubahan fitur BYD Atto 1 NIK 2026: Dynamic Rp210 juta, Premium Rp245 juta, retract mirror, shift by wire, electric seat di kedua varian, 360 camera Premium, layar PAD fixed, dan fitur yang disesuaikan.'
        keywords={[
          ...keywordSets.localDealer,
          'perubahan fitur BYD Atto 1',
          'BYD Atto 1 NIK 2026',
          'fitur BYD Atto 1 2026',
          'BYD Atto 1 Dynamic 2026',
          'BYD Atto 1 Premium 2026',
          'BYD Atto 1 shift by wire',
          'BYD Atto 1 retract mirror',
          'harga BYD Atto 1 2026',
          'BYD Atto 1 BSD Serpong',
        ]}
        path='/blog/perubahan-fitur-byd-atto-1-nik-2026'
        image={heroAtto1}
        type='article'
        jsonLd={[
          localBusinessJsonLd(),
          productJsonLd({
            name: 'BYD Atto 1 NIK 2026',
            description:
              'BYD Atto 1 NIK 2026 dengan update fitur Dynamic dan Premium untuk pembeli BSD Serpong, Tangerang, dan Gading Serpong.',
            image: heroAtto1,
            path: '/blog/perubahan-fitur-byd-atto-1-nik-2026',
            lowPrice: 210000000,
            highPrice: 245000000,
            offerCount: 2,
          }),
          articleJsonLd({
            title: 'Perubahan Fitur BYD Atto 1 NIK 2026 | Dynamic & Premium',
            description:
              'Blog SEO yang menjelaskan perubahan fitur BYD Atto 1 NIK 2026 pada varian Dynamic dan Premium, lengkap dengan foto detail interior.',
            image: heroAtto1,
            path: '/blog/perubahan-fitur-byd-atto-1-nik-2026',
            datePublished: '2026-05-18',
            dateModified: '2026-05-18',
          }),
          breadcrumbJsonLd([
            { name: 'Beranda', path: '/' },
            { name: 'Blog', path: '/blog' },
            {
              name: 'Perubahan Fitur BYD Atto 1 NIK 2026',
              path: '/blog/perubahan-fitur-byd-atto-1-nik-2026',
            },
          ]),
          faqJsonLd,
        ]}
      />

      <Box
        component='main'
        sx={{ backgroundColor: '#f4f7fb', overflow: 'hidden' }}
      >
        <HeroSection />
        <SummarySection />
        <VariantSection />
        <VisualSection />
        <BuyerNoteSection />
        <FaqSection />
        <CtaSection />
      </Box>
    </>
  );
}

function HeroSection() {
  return (
    <Box
      component='section'
      aria-labelledby='perubahan-atto1-title'
      sx={{
        position: 'relative',
        minHeight: { xs: '88vh', md: '94vh' },
        display: 'flex',
        alignItems: 'flex-end',
        pt: { xs: 10, md: 11 },
        backgroundColor: '#111827',
      }}
    >
      <Box
        component='img'
        src={heroAtto1}
        alt='Perubahan fitur BYD Atto 1 NIK 2026 layar PAD fixed'
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(180deg, rgba(0,0,0,0.28) 0%, rgba(0,0,0,0.16) 38%, rgba(0,0,0,0.84) 100%)',
        }}
      />
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          width: '100%',
          maxWidth: 1180,
          mx: 'auto',
          px: { xs: 2, md: 5 },
          pb: { xs: 5, md: 7 },
          color: '#fff',
        }}
      >
        <Typography sx={eyebrowDark}>BYD Atto 1 NIK 2026</Typography>
        <Typography id='perubahan-atto1-title' component='h1' sx={heroTitle}>
          Perubahan fitur BYD Atto 1 baru: apa yang bertambah dan apa yang
          disesuaikan?
        </Typography>
        <Typography sx={heroText}>
          Atto 1 NIK 2026 membawa beberapa update penting seperti retract
          mirror, shift by wire, electric seat untuk Dynamic dan Premium, 360
          camera untuk Premium, serta layar PAD fixed.
        </Typography>
        <Box sx={{ mt: 3, display: 'flex', gap: 1.4, flexWrap: 'wrap' }}>
          <Button
            href={waLink}
            target='_blank'
            rel='noopener noreferrer'
            variant='contained'
            sx={buttonPrimary}
          >
            Tanya Update Atto 1
          </Button>
          <Button
            component={RouterLink}
            to='/jelajahi-atto1'
            variant='outlined'
            sx={buttonGhost}
          >
            Lihat halaman Atto 1
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

function SummarySection() {
  return (
    <Box
      component='article'
      sx={{
        px: { xs: 2, md: 6 },
        py: { xs: 7, md: 9 },
        backgroundColor: '#fff',
      }}
    >
      <Box sx={{ maxWidth: 940, mx: 'auto' }}>
        <Typography sx={eyebrow}>Ringkasan Perubahan</Typography>
        <Typography component='h2' sx={sectionTitle}>
          Update Atto 1 NIK 2026 perlu dilihat dari dua sisi: fitur baru dan
          fitur yang disesuaikan
        </Typography>
        <Typography sx={{ ...bodyText, mt: 1.5 }}>
          Secara umum, Atto 1 baru terlihat lebih praktis untuk pemakaian harian
          karena mendapatkan shift by wire, retract mirror, dan electric seat
          6-way di kedua varian. Premium juga mendapat 360 camera. Di sisi lain,
          ada beberapa penyesuaian seperti layar PAD yang fixed, defogger yang
          tidak tersedia, dan jumlah airbag Premium yang disesuaikan.
        </Typography>
      </Box>
    </Box>
  );
}

function VariantSection() {
  return (
    <Box
      component='section'
      aria-labelledby='variant-atto1-update-title'
      sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 } }}
    >
      <Box sx={{ maxWidth: 1180, mx: 'auto' }}>
        <Typography sx={eyebrow}>Dynamic vs Premium</Typography>
        <Typography
          id='variant-atto1-update-title'
          component='h2'
          sx={sectionTitle}
        >
          Daftar perubahan fitur Atto 1 NIK 2026 per varian
        </Typography>
        <Box
          sx={{
            mt: 3,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: 2.5,
          }}
        >
          {variantUpdates.map((item) => (
            <Box key={item.variant} sx={infoCard}>
              <Typography
                sx={{
                  color: '#2d6cdf',
                  fontWeight: 900,
                  textTransform: 'uppercase',
                  fontSize: '0.82rem',
                }}
              >
                {item.price}
              </Typography>
              <Typography
                component='h3'
                sx={{
                  mt: 0.6,
                  fontSize: { xs: '1.5rem', md: '1.8rem' },
                  fontWeight: 900,
                }}
              >
                {item.variant}
              </Typography>
              <Box component='ul' sx={{ mt: 2, mb: 0, pl: 2.4 }}>
                {item.points.map((point) => (
                  <Box
                    component='li'
                    key={point}
                    sx={{ mb: 0.8, color: '#4b5563', lineHeight: 1.65 }}
                  >
                    {point}
                  </Box>
                ))}
              </Box>
            </Box>
          ))}
        </Box>
        <Typography sx={{ mt: 2, color: '#6b7280', fontSize: '0.92rem' }}>
          *Harga indikatif NIK 2026 dan dapat berubah mengikuti OTR, promo, dan
          ketersediaan unit.
        </Typography>
      </Box>
    </Box>
  );
}

function VisualSection() {
  return (
    <Box
      component='section'
      aria-labelledby='visual-atto1-update-title'
      sx={{
        px: { xs: 2, md: 6 },
        py: { xs: 7, md: 9 },
        backgroundColor: '#fff',
      }}
    >
      <Box sx={{ maxWidth: 1180, mx: 'auto' }}>
        <Typography sx={eyebrow}>Foto Detail</Typography>
        <Typography
          id='visual-atto1-update-title'
          component='h2'
          sx={sectionTitle}
        >
          Foto perubahan fitur Atto 1 baru
        </Typography>
        <Typography sx={{ ...bodyText, mt: 1.5, maxWidth: 840 }}>
          Galeri ini membantu calon pembeli memahami perubahan secara visual,
          bukan hanya dari daftar fitur.
        </Typography>
        <Box
          sx={{
            mt: 3,
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: '1fr 1fr',
              lg: 'repeat(5, 1fr)',
            },
            gap: 2,
          }}
        >
          {visualCards.map((item) => (
            <Box key={item.title} sx={imageCard}>
              <Box
                component='img'
                src={item.image}
                alt={item.title}
                loading='lazy'
                sx={{
                  width: '100%',
                  height: { xs: 260, lg: 220 },
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
              <Box sx={{ p: 2 }}>
                <Typography sx={{ fontWeight: 900, color: '#111827' }}>
                  {item.title}
                </Typography>
                <Typography
                  sx={{
                    mt: 0.8,
                    color: '#4b5563',
                    lineHeight: 1.6,
                    fontSize: '0.92rem',
                  }}
                >
                  {item.text}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function BuyerNoteSection() {
  return (
    <Box
      component='section'
      sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 } }}
    >
      <Box sx={{ maxWidth: 940, mx: 'auto' }}>
        <Typography sx={eyebrow}>Catatan Pembeli</Typography>
        <Typography component='h2' sx={sectionTitle}>
          Jadi, varian mana yang lebih masuk akal?
        </Typography>
        <Typography sx={{ ...bodyText, mt: 1.5 }}>
          Dynamic menarik untuk pembeli yang fokus ke harga entry dan sekarang
          ingin fitur praktis seperti retract mirror, electric seat, dan shift
          by wire. Premium lebih cocok jika Anda butuh kamera 360 dan range yang
          lebih tinggi. Karena ada penyesuaian fitur, sebaiknya cek langsung
          unit, warna, promo, dan simulasi cicilan sebelum booking.
        </Typography>
      </Box>
    </Box>
  );
}

function FaqSection() {
  return (
    <Box
      component='section'
      aria-labelledby='faq-atto1-update-title'
      sx={{
        px: { xs: 2, md: 6 },
        py: { xs: 7, md: 9 },
        backgroundColor: '#fff',
      }}
    >
      <Box sx={{ maxWidth: 920, mx: 'auto' }}>
        <Typography
          id='faq-atto1-update-title'
          component='h2'
          sx={sectionTitle}
        >
          FAQ perubahan fitur BYD Atto 1
        </Typography>
        <Box sx={{ mt: 2.5, display: 'grid', gap: 1.3 }}>
          {faqItems.map((item) => (
            <Box
              key={item.question}
              component='details'
              sx={{
                p: 2,
                borderRadius: '8px',
                backgroundColor: '#f8fafc',
                border: '1px solid rgba(17,24,39,0.08)',
                '& summary': {
                  cursor: 'pointer',
                  fontWeight: 900,
                  color: '#111827',
                },
              }}
            >
              <Box component='summary'>{item.question}</Box>
              <Typography sx={{ mt: 1.2, color: '#4b5563', lineHeight: 1.75 }}>
                {item.answer}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function CtaSection() {
  return (
    <Box
      component='section'
      sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 } }}
    >
      <Box
        sx={{
          maxWidth: 1080,
          mx: 'auto',
          borderRadius: '8px',
          backgroundColor: '#111827',
          color: '#fff',
          px: { xs: 2.5, md: 4 },
          py: { xs: 3.5, md: 4.5 },
          textAlign: 'center',
        }}
      >
        <Typography component='h2' sx={sectionTitleDark}>
          Mau cek unit Atto 1 NIK 2026?
        </Typography>
        <Typography
          sx={{
            mt: 1.5,
            maxWidth: 760,
            mx: 'auto',
            color: 'rgba(255,255,255,0.78)',
            lineHeight: 1.8,
          }}
        >
          Hubungi Junius untuk konfirmasi harga, promo, varian Dynamic atau
          Premium, ketersediaan warna, dan jadwal test drive BYD Atto 1 di BYD
          BSD Serpong.
        </Typography>
        <Box
          sx={{
            mt: 3,
            display: 'flex',
            justifyContent: 'center',
            gap: 1.5,
            flexWrap: 'wrap',
          }}
        >
          <Button
            href={waLink}
            target='_blank'
            rel='noopener noreferrer'
            variant='contained'
            sx={buttonPrimary}
          >
            Chat WhatsApp Junius
          </Button>
          <Button
            component={RouterLink}
            to='/blog/harga-byd-atto-1-bsd-serpong-junius'
            variant='outlined'
            sx={buttonGhost}
          >
            Lihat harga Atto 1
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

const eyebrow = {
  color: '#4c5867',
  fontWeight: 800,
  letterSpacing: 0.4,
  textTransform: 'uppercase',
  fontSize: '0.82rem',
};

const eyebrowDark = {
  display: 'inline-flex',
  px: 1.2,
  py: 0.65,
  borderRadius: '999px',
  backgroundColor: 'rgba(255,255,255,0.12)',
  border: '1px solid rgba(255,255,255,0.2)',
  fontSize: '0.78rem',
  fontWeight: 900,
  letterSpacing: 0.4,
  textTransform: 'uppercase',
};

const heroTitle = {
  mt: 1.6,
  fontSize: { xs: '2.25rem', sm: '3.2rem', md: '4.8rem' },
  fontWeight: 900,
  lineHeight: 0.98,
  maxWidth: 960,
};

const heroText = {
  mt: 1.5,
  maxWidth: 760,
  fontSize: { xs: '1rem', md: '1.08rem' },
  lineHeight: 1.8,
  color: 'rgba(255,255,255,0.9)',
};

const sectionTitle = {
  mt: 1,
  fontSize: { xs: '2rem', md: '3rem' },
  fontWeight: 900,
  color: '#111827',
  lineHeight: 1.05,
};

const sectionTitleDark = {
  fontSize: { xs: '2rem', md: '3rem' },
  fontWeight: 900,
  lineHeight: 1.05,
};

const bodyText = {
  color: '#4b5563',
  lineHeight: 1.8,
  fontSize: { xs: '1rem', md: '1.05rem' },
};

const infoCard = {
  p: 2.4,
  borderRadius: '8px',
  backgroundColor: '#fff',
  border: '1px solid rgba(17,24,39,0.08)',
  boxShadow: '0 12px 26px rgba(16,24,40,0.06)',
};

const imageCard = {
  overflow: 'hidden',
  borderRadius: '8px',
  backgroundColor: '#fff',
  border: '1px solid rgba(17,24,39,0.08)',
  boxShadow: '0 12px 26px rgba(16,24,40,0.08)',
};

const buttonPrimary = {
  px: 3.2,
  py: 1.1,
  borderRadius: '999px',
  textTransform: 'none',
  fontWeight: 900,
  backgroundColor: '#1f5fd1',
  '&:hover': { backgroundColor: '#184ca8' },
};

const buttonGhost = {
  px: 3.2,
  py: 1.1,
  borderRadius: '999px',
  textTransform: 'none',
  fontWeight: 900,
  color: '#fff',
  borderColor: 'rgba(255,255,255,0.68)',
  '&:hover': {
    borderColor: '#fff',
    backgroundColor: 'rgba(255,255,255,0.1)',
  },
};

export default PerubahanAtto1Detail;
